<script lang="ts">
    import { page } from '$app/state';
    import { onMount } from 'svelte';
    import { fromDocument } from '$lib/services/helpers/cookies';
    import { isNative, sendPlayerLoginNativeEvent } from '$lib/services/native';
    import { COOKIES } from '$src/lib/services/legacy/standaloneRegistration/constants';
    import { URLPrefixToAPIMarket } from '$src/lib/services/market/constants';
    import { captureException } from '@sentry/svelte';

    onMount(async () => {
        const cookies = fromDocument(document);
        const isPlayerLoginCookiePresent = cookies.get(COOKIES.NATIVE_PLAYER_LOGIN_EVENT);
        const sessionId = page.data.sessionId;
        const playerData = page.data.player;

        const shouldEmitNativePlayerLoginEvent =
            isPlayerLoginCookiePresent && isNative() && sessionId && playerData;

        if (shouldEmitNativePlayerLoginEvent) {
            try {
                const userId = playerData.playerId;
                const email = playerData.contactInfo.email;
                const marketCode = URLPrefixToAPIMarket[page.data.market.slug];
                const userName = playerData.casumoName;

                sendPlayerLoginNativeEvent({ userId, email, marketCode, sessionId, userName });
            } catch (e) {
                captureException(e);
            }
            cookies.delete(COOKIES.NATIVE_PLAYER_LOGIN_EVENT, { path: '/' });
        }
    });
</script>
